var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
var Block = function () { return (React.createElement("div", { className: "sui-mb-6" },
    React.createElement(SkeletonBlock, { aspect: "square", height: 20 }))); };
var Lines = function () { return (React.createElement("div", { className: "sui-mb-6" },
    React.createElement(SkeletonLine, { fullWidth: true, variant: "multi", numberOfLines: 3 }))); };
var SkeletonMW = function () { return (React.createElement(React.Fragment, null, __spreadArray([], Array(3), true).map(function (item, i) { return (React.createElement("div", { key: i, className: "sui-mb-12" },
    React.createElement(Block, null),
    React.createElement(Lines, null),
    i > 0 && React.createElement(Block, null),
    React.createElement("div", { className: "sui-h-2" }))); }))); };
var SkeletonDTW = function () { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "sui-w-full sui-mb-6" },
        React.createElement(Lines, null),
        React.createElement("div", { className: "sui-h-8" })),
    React.createElement("div", { className: "sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 sui-gap-10" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6 sui-pr-7" },
            React.createElement(Lines, null),
            React.createElement("div", { className: "sui-h-8" }),
            React.createElement(Lines, null)),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6 sm:sui-pl-6" },
            React.createElement(Lines, null),
            React.createElement("div", { className: "sui-h-8" }),
            React.createElement(Lines, null))))); };
var RenderSkeleton = function (_a) {
    var isMobile = _a.isMobile;
    return isMobile ? React.createElement(SkeletonMW, null) : React.createElement(SkeletonDTW, null);
};
export var PageSkeletonLoader = function (_a) {
    var isMobile = _a.isMobile, isLoading = _a.isLoading, _b = _a.isTransparent, isTransparent = _b === void 0 ? false : _b;
    return isLoading ? (
    // Container must have position relative to allow absolute positioning of the loader
    React.createElement("div", { className: "\n      ".concat(isTransparent ? '' : 'sui-bg-primary', "\n      sui-absolute sui-top-0 sui-bottom-0 sui-left-0 sui-right-0\n    ") },
        React.createElement(RenderSkeleton, { isMobile: isMobile }))) : (React.createElement(React.Fragment, null));
};
